module.exports = __webpack_public_path__ + "img/Metatarsi180_ok.5522a97a.png";